import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { ROUTING_CONGELAMIENTOS_SALDOS } from "@constants/url.constant";
import { IInformationModal } from "@interfaces/modal.interface";
import { ModalService } from "@services/modal/modal.service";
import { GenericErrorOps } from "@shared/components/generic-error/interfaces/generic-error-ops.interface";

@Component({
    selector: "app-congelamiento-saldos-home",
    templateUrl: "congelamiento-saldos-home.component.html",
    styleUrls: ["congelamiento-saldos-home.component.scss"],
    standalone: false
})
export class CongelamientoSaldosHomeComponent {
  public loading: boolean = false;
  public error: boolean = false;
  public enableButtonRetry: boolean = false;
  public errorOps: GenericErrorOps;

  constructor(
    private readonly router: Router,   
    private readonly modalService: ModalService
  ) {}

  async iniciarCongelamientoSaldos() {
    this.loading = true;
    this.router.navigate([ROUTING_CONGELAMIENTOS_SALDOS.CONGELAMIENTO_SALDOS_BASE, ROUTING_CONGELAMIENTOS_SALDOS.CONGELAMIENTO_SALDOS_URL, ROUTING_CONGELAMIENTOS_SALDOS.CONGELAMIENTO_SALDOS_URL]);
    this.loading = false;
  }


  async openInformationModal() {
    const modal: IInformationModal = {
      title: "Conoce más del Congelamiento de saldos",
      description: [
        "<h3>¿Qué es la Cuenta Corriente del Fondo de Pensiones? </h3>Es una cuenta diferente a las bancarias, que pertenece a los Fondos de Pensiones y es administrada por las AFP.",
        "<h3>¿Quiénes pueden solicitar congelar los saldos?</h3><ul><li>Todos los afiliados que comiencen su trámite de pensión (Pensión de Vejez, Vejez Anticipada e Invalidez) y que no reciban pago inmediato (personas que el saldo de su cuenta individual genere una pensión menor a 3UF).</li><li>Beneficiarios de una Pensión de Sobrevivencia que están iniciando el trámite.</li></ul>",
        "<h3>¿Cuánto dura el Congelamiento de los saldos?</h3>Esto se mantiene activo durante el trámite de pensión, hasta que:<ul><li>Se selecciona la modalidad de pensión (Retiro Programado o Renta Vitalicia).</li><li>Se desiste del trámite de pensión.</li></ul>",        
      ],
      primaryButtonText: "Aceptar",
      primaryButtonCallback: () => this.modalService.closeModal(),
      closeButtonCallback: () => this.modalService.closeModal(),
    };
    await this.modalService.openInformationModal(modal);
  }
}
